import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelToTitle',
  standalone: false
})
export class CamelCaseToTitleCasePipe implements PipeTransform {
  transform(value: string) {
    if (!value) return '';

    // should be able to handle abbreviations
    // e.g. CSRTasks -> CSR Tasks
    const pascalCase = value.charAt(0).toUpperCase() + value.substr(1);
    return pascalCase
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
      .replace(/([a-z])([0-9])/gi, '$1 $2')
      .replace(/([0-9])([a-z])/gi, '$1 $2');
  }
}
